import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const LogoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 8px 0;

  p {
    font-size: 13px;
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-weight: 900;
  }

  img {
    display: flex;
    height: 49px;
    object-fit: contain;
  }

  @media (max-width: ${defaultBreakpoints.medium}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
